/* src/app/timeline-skip/modals/skip-vor-and-absence/skip-vor-and-absence.component.scss */
/*# sourceMappingURL=skip-vor-and-absence.component.css.map */
